:host {
    display: block;
    box-sizing: border-box;
}

:host(.rs-radio-group--flex) {
    display: flex;
    flex-direction: row;
    align-items: center;
}
